




















import OzBaseSnackbar from 'library/v4/components/OzBaseSnackbar.vue'
import { Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { GlobalSnackbarNotification } from 'vuexstore/modules/global_snackbar'

const globalSnackbar = namespace('globalSnackbar')

@Component({
  components: { OzBaseSnackbar },
})
export default class GlobalSnackbar extends Vue {
  @globalSnackbar.Getter snackbarArray!: GlobalSnackbarNotification[]

  calculateSnackbarPosition(snackbarIndex: number): string {
    // 49 is the height of snackbar plus margin between snackbars
    // each subsequent snackbar is height plus margin of a snackbar from the top of the viewport plus initial gap (16px)
    return `${snackbarIndex * 49 + 16}px`
  }
}
